import { render, staticRenderFns } from "./LocalisationHandler.vue?vue&type=template&id=86ca2de0&"
import script from "./LocalisationHandler.vue?vue&type=script&lang=js&"
export * from "./LocalisationHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports